import React, {useState, useEffect} from "react";
import {Box, IconButton, ListItemButton, ListItemText, List, Menu, Divider} from "@mui/material";
import {useNavigate} from "react-router-dom";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {useTheme} from "../shared/ConsolidatedThemeProvider";
import {useLogin} from "./login/LoginProvider";
import getBrxSupport from "../supportAccount/gql/GetBrxSupport.graphql";
import getSupportAccountValues from "../supportAccount/gql/GetSupportAccountInfo.graphql";
import {useQuery} from "@apollo/client";
import {map} from "underscore";

const MainMenu = () => {
  const {toggleActiveTheme} = useTheme();
  const {isUserFullAdmin, user, logout} = useLogin();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !!anchorEl;
  const navigate = useNavigate();

  const brxSupportGroup = useQuery(getBrxSupport, {
    variables: {username: user?.username},
    skip: !user?.username,
  });

  const supportAccountValues = useQuery(getSupportAccountValues, {
    variables: {username: user?.username},
    skip: !user?.username,
  });

  useEffect(() => {
    if (brxSupportGroup.error) {
      console.error(brxSupportGroup.error);
    }
    if (supportAccountValues.error) {
      console.error(supportAccountValues.error);
    }
  }, [brxSupportGroup.error, supportAccountValues.error]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isUserAFullAdmin = isUserFullAdmin();
  const isUserBrxSupport = brxSupportGroup?.data?.brxSupport?.result;

  const isSupportAccountValueEmpty = map(
    supportAccountValues?.data?.getSupportAccountInformation,
    (value) => value === "",
  ).includes(true);

  return (
    <>
      <IconButton onClick={handleClick}>
        <MenuOutlinedIcon />
      </IconButton>
      <Menu
        id="main-menu"
        aria-labelledby="main-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box>
          <List disablePadding>
            {!isUserAFullAdmin ?
              null :
              (
                <>
                  <ListItemButton
                    id="users-button"
                    aria-controls="user-button"
                    aria-label="users-button"
                    onClick={() => {
                      navigate("/users");
                      handleClose();
                    }}
                  >
                    <ListItemText primary="Manage Users" />
                  </ListItemButton>
                  <ListItemButton
                    id="regulations-button"
                    aria-controls="regulations-button"
                    aria-label="regulations-button"
                    onClick={() => {
                      navigate("/");
                      handleClose();
                    }}
                  >
                    <ListItemText primary="Manage Regulations" />
                  </ListItemButton>
                  <ListItemButton
                    id="regulation-groups-button"
                    aria-controls="regulation-groups-button"
                    aria-label="regulation-groups-button"
                    onClick={() => {
                      navigate("/groups");
                      handleClose();
                    }}
                  >
                    <ListItemText primary="Manage Regulation Groups" />
                  </ListItemButton>
                  {isUserBrxSupport && !isSupportAccountValueEmpty && (
                    <ListItemButton
                      id="access-support-account-button"
                      aria-controls="access-support-account-button"
                      aria-label="access-support-account-button"
                      onClick={() => {
                        navigate("/supportAccountInfo");
                        handleClose();
                      }}
                    >
                      <ListItemText primary="Access Support Account Info" />
                    </ListItemButton>
                  )}
                  <Divider component="li" />
                  <ListItemButton
                    id="settings-button"
                    aria-controls="settings-button"
                    aria-label="settings-button"
                    onClick={() => {
                      navigate("/settings");
                      handleClose();
                    }}
                  >
                    <ListItemText primary="Settings" />
                  </ListItemButton>
                </>
              )}
            <ListItemButton
              id="toggle-theme-button"
              aria-controls="toggle-theme-button"
              aria-label="toggle-theme-button"
              onClick={() => toggleActiveTheme()}
            >
              <ListItemText primary="Toggle Theme" />
            </ListItemButton>
            <ListItemButton
              id="logout-button"
              aria-controls="logout-button"
              aria-label="logout-button"
              onClick={() => logout()}
            >
              <ListItemText primary="Logout" />
            </ListItemButton>
          </List>
        </Box>
      </Menu>
    </>
  );
};

export default MainMenu;
